import { Injectable } from '@angular/core';
import { HeaderService } from '../core/services/header.service';
import { PortalEnum } from '../shared/enums/portal.enum';
import { Brands } from '../shared/enums/brands.enum';
import { BrandPortal } from '../shared/models/brandPortal.model';

@Injectable()
export class LogoClinicianResolve {
  constructor(private headerService: HeaderService) { }

  resolve() {
    let brand : Brands = JSON.parse(sessionStorage.getItem("brand"));   
    let brandPortal: BrandPortal = { brand :  brand, portal : PortalEnum.ScreenerPortal};
    this.headerService.initLogo(brandPortal);
  }
}
